module.exports = __webpack_public_path__ + "f389e0e4c177b835b64a17ea34d1936e.png";